import { ArrowUpRight } from "lucide-react";

const MONTHS = ["Jul", "Aug", "Sep", "Oct", "Nov", "Dec", "Jan", "Feb", "Mar", "Apr", "May", "Jun"];
const GITHUB_PROFILE_URL = "https://github.com/Efwan016";
const CHART_URL = "https://gh-heat.anishroy.com/api/Efwan016/svg?colors=334155,fed7aa,fdba74,fb923c,ea580c&darkMode=true&transparent=true&borderColor=0f172a&showMonthLabels=false&showDayLabels=false&showLegend=false&padding=8&cellSize=14&cellGap=3&radius=2";

const GitHubActivity = () => (
  <a
    href={GITHUB_PROFILE_URL}
    target="_blank"
    rel="noopener noreferrer"
    className="group block overflow-hidden rounded-[28px] border border-orange-300/15 p-[18px] shadow-[0_20px_70px_rgba(0,0,0,0.24)] backdrop-blur-xl transition hover:border-orange-300/35 sm:p-[24px]"
    aria-label="Open Efwan016 GitHub profile"
  >
    <div className="flex flex-col gap-4 border-b border-white/10 pb-4 sm:flex-row sm:items-center sm:justify-between">
      <div className="flex items-center gap-3">
        <span className="grid h-11 w-11 place-items-center rounded-2xl border border-orange-300/20 bg-orange-400/10 text-orange-300">
          <i className="fa-brands fa-github text-xl" aria-hidden="true" />
        </span>
        <div>
          <p className="text-xl font-bold uppercase tracking-[0.18em] text-orange-300">GitHub track record</p>
          <p className="mt-1 text-lg font-bold text-white">Contributions <span className="text-orange-300">@Efwan016</span></p>
        </div>
      </div>
      <span className="inline-flex w-fit items-center gap-2 rounded-full border border-orange-400/40 bg-orange-500/10 px-6 py-3 font-semibold text-orange-300 transition hover:-translate-y-0.5 hover:bg-orange-500 hover:text-white">
        <span className="h-2 w-2 rounded-full bg-orange-300 shadow-[0_0_10px_rgba(253,186,116,0.9)]" />
        View GitHub profile <ArrowUpRight size={14} aria-hidden="true" />
      </span>
    </div>

    <div className="mt-5 overflow-x-auto pb-2">
      <div className="min-w-[760px]">
        <div className="ml-10 grid grid-cols-12 gap-2 px-1 text-center text-lg font-semibold text-white">
          {MONTHS.map((month) => <span key={month}>{month}</span>)}
        </div>
        <div className="mt-2 flex gap-2">
          <div className="grid w-8 shrink-0 grid-rows-3 content-around py-2 text-right text-lg font-semibold text-white">
            <span>Mon</span><span>Wed</span><span>Fri</span>
          </div>
          <img
            src={CHART_URL}
            alt="GitHub contribution graph for Efwan016 over the last year"
            width={760}
            height={60}
            className="min-w-0 flex-1 opacity-95 transition duration-300 group-hover:opacity-100"
            loading="lazy"
          />
        </div>
        <div className="ml-10 mt-2 flex items-center gap-2 text-lg font-semibold text-white">
          <span>Less</span>
          {["bg-slate-700", "bg-orange-200", "bg-orange-300", "bg-orange-400", "bg-orange-600"].map((color) => (
            <span key={color} className={`h-3.5 w-3.5 rounded-sm ${color}`} />
          ))}
          <span>More</span>
        </div>
      </div>
    </div>
    <p className="mt-2 text-lg font-semibold text-slate-500">Public contribution activity over the last year · updated daily.</p>
  </a>
);

export default GitHubActivity;
